import { render, staticRenderFns } from "./spikeItem.vue?vue&type=template&id=4f161822&scoped=true&"
import script from "./spikeItem.vue?vue&type=script&lang=ts&"
export * from "./spikeItem.vue?vue&type=script&lang=ts&"
import style0 from "./spikeItem.vue?vue&type=style&index=0&id=4f161822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f161822",
  null
  
)

export default component.exports